import { Component, OnDestroy, OnInit } from '@angular/core';
import { StateService, Transition } from '@uirouter/core';
import { CurrencyPipe } from '@angular/common';
import { Subscription } from 'rxjs';

import { Analytics, Cloudinary, SessionStorage, XmStore, XmStoreUtil } from 'core/services';
import { AddonRouteType, USAGE_SUMMARY_STATE } from 'my-account/constants';
import { Util } from 'services/util';

import { CmsTravelRates } from 'store/cms/models';
import { InternationalRate } from 'store/international-rates/models';
import { Addon, AddonCollections } from 'store/addons';

@Component({
    selector: 'xm-travel-rate-search',
    templateUrl: './travel-rate-search.html',
    styleUrls: ['./travel-rate-search.scss'],
    standalone: false
})
export class XmTravelRateSearch implements OnInit, OnDestroy {
    public pageData: CmsInternationalTravelRates;
    public showInitialState: boolean = true;
    public showGtpEligibleCard: boolean;
    public showGtpInEligibleCard: boolean;
    public showCoverageNotAvailable: boolean;
    public noCoverageDescription: string;
    public gtpEligibleText: string;
    public gtpIneligibleText: string;
    public payAsGoCardResultState: string;
    public payAsGoRateDetails: CmsInternationalDetailsDescription[];
    public gtpData: Addon;
    public eligibleIcon: MediaImageOptions;
    public inEligibleIcon: MediaImageOptions;
    public notFoundIcon: MediaImageOptions;
    public rateDetails: InternationalRate;
    public showGtpLink: boolean;
    public hasSelectedCountry: boolean = false;
    public countryFound: boolean = false;

    private xmStore: XmStore;
    private subscriptions: Subscription[] = [];
    private state: StateService;
    private transition: Transition;
    private sessionStorage: SessionStorage;
    private analytics: Analytics;

    constructor(analytics: Analytics, currencyPipe: CurrencyPipe, state: StateService, xmStore: XmStore, transition: Transition, sessionStorage: SessionStorage) {
        Object.assign(this, { analytics, currencyPipe, state, xmStore, transition, sessionStorage });
    }

    public ngOnInit(): void {
        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<CmsTravelRates>(CmsTravelRates), (result: CmsTravelRates) => {
            this.pageData = result.travelRates;

            this.notFoundIcon = {
                mobile: Cloudinary.generateMediaFromCms(this.pageData.notFoundIcon)
            };
        }));

        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<AddonCollections>(AddonCollections, { filters: { lineId: this.state.params.line_id } }), (addons: AddonCollections) => {
            this.gtpData = addons.addons.find((addon: Addon) => addon.isGtp);
            this.showGtpLink = this.gtpData.isInactive;
        }));
    }

    public setSelectedCountry(rateDetails: InternationalRate): void {
        this.hasSelectedCountry = true;
        this.rateDetails = rateDetails;
        this.countryFound = Boolean(this.rateDetails);

        const analyticsParams: object = {
            type: 'authenticated travel rates search',
            term: rateDetails && rateDetails.displayName
        };

        this.analytics.sendCustomEvent('rate-search', analyticsParams);
    }

    public launchGtpFlow(): void {
        this.state.go('account.activity.addon.review', { addon_type: AddonRouteType.GTP, intent: 'add' });
    }

    public navigateBack(): void {
        if ((this.transition.from().name === 'account.activity.usage' || this.transition.from().name === 'account.billing.usage') && this.transition.params('from')) {
            this.state.go(this.transition.from().name,
                { statement_line_id: this.transition.params('from').statement_line_id, activity: this.transition.params('from').activity, startDate: this.transition.params('from').startDate,
                    endDate: this.transition.params('from').endDate, name: this.transition.params('from').name, lineNumber: this.transition.params('from').lineNumber });
        } else if (this.sessionStorage.get(USAGE_SUMMARY_STATE)) {
            this.state.go('account.billing.landing');
        } else {
            this.state.go('account.activity.details.travel', { line_id: this.state.params.line_id });
        }
    }

    public ngOnDestroy(): void {
        Util.unsubscribeAll(this.subscriptions);
    }
}
